import React, { createContext, useContext } from 'react';
import type { ReactNode } from 'react';

interface AuthContextValue {
  getAccessToken: () => Promise<string | undefined>;
  instanceId?: string;
}

const AuthContext = createContext<AuthContextValue | undefined>(undefined);

interface AuthProviderProps {
  getAccessToken: () => Promise<string | undefined>;
  instanceId?: string;
  children: ReactNode;
}

export function AuthProvider({ getAccessToken, instanceId, children }: AuthProviderProps) {
  const value: AuthContextValue = {
    getAccessToken,
    instanceId,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
